import { motion } from "framer-motion";
import { SERVICES } from "@/components/site/data";

export default function Services() {
  return (
    <section id="services" className="bg-[#efe9de] py-24 md:py-36 border-y border-black/10" data-testid="services">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <p className="overline mb-5">What I Do</p>
            <h2 className="font-serif text-4xl md:text-5xl text-[#1a1a17] tracking-tight max-w-xl">
              Services built around <span className="italic text-[#0e5b45]">your</span> milestones
            </h2>
          </div>
          <p className="text-stone-500 max-w-sm md:text-right">
            End-to-end mutual fund advisory — from your first SIP to a fully funded retirement.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-black/10 border border-black/10">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: (i % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
                className="group bg-white hover:bg-[#f6f2eb] p-9 lg:p-10 transition-colors duration-500"
                data-testid={`service-${i}`}
              >
                <Icon
                  size={28}
                  className="text-[#0e5b45] mb-8 group-hover:scale-110 transition-transform duration-500 origin-left"
                  strokeWidth={1.4}
                />
                <h3 className="font-serif text-2xl text-[#1a1a17] mb-3">{s.title}</h3>
                <p className="text-stone-600 leading-relaxed text-sm md:text-base">{s.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
